var $f0f87877eef2c862$exports = {};
$f0f87877eef2c862$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Spalv\u{173} parinkiklis`,
    "colorSwatch": `spalv\u{173} pavyzdys`,
    "transparent": `skaidrus`,
    "twoDimensionalSlider": `2D slankiklis`
};


export {$f0f87877eef2c862$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
